// Given an object like this in the $scope:
// $scope.savingsExample = {
//   savingsAmount: 24503,
//   savingsPercent: 9
// };
//
// And a directive like this in the HTML:
// <div aptitude-savings-display="savingsExample.savingsPercent"></div>
//
// You will get a simple bar gauge of the percentage of something.

export default function AptitudeSavingsDisplay() {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      notApplicable: '=',
      savings: '=aptitudeSavingsDisplay'
    },
    template:
      '<div class="savings-tab" ng-show="savings != null" ng-class="generateClass()">' +
      '  <div class="savings-percent">{{ savings }}%</div>' +
      '</div>',
    replace: true,
    controller: function ($scope) {
      'ngInject';

      $scope.generateClass = function () {
        if ($scope.notApplicable) {
          $scope.savings = 'N/A';
          return 'savings-tab-na-saving';
        } else if ($scope.savings >= 0) {
          return 'savings-tab-saving';
        } else {
          return 'savings-tab-not-saving';
        }
      };
    }
  };
}
